import DropdownMenuItemCheckbox from "@excalidraw/excalidraw/components/dropdownMenu/DropdownMenuItemCheckbox";

import { useDrawolaT } from "../storage/i18n";

import { useShapeLibraryPreference } from "./useShapeLibraryPreference";

export const ShapeLibraryPreferenceItem = () => {
  const t = useDrawolaT();
  const [enabled, setEnabled] = useShapeLibraryPreference();

  return (
    <DropdownMenuItemCheckbox
      checked={enabled}
      onSelect={(event) => {
        setEnabled(!enabled);
        event.preventDefault();
      }}
    >
      {t("shapeLibrary.menuEntry")}
    </DropdownMenuItemCheckbox>
  );
};

ShapeLibraryPreferenceItem.displayName = "ShapeLibraryPreferenceItem";
